module.exports = __webpack_public_path__ + "img/cn2.8ecde27.png";